import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { ROUTES } from "./constants";
import lazyWithRetry from "../utils/lazyWithRetry";

const HomePage = lazyWithRetry(() => import("../pages/Home"));

const PhonePage = lazyWithRetry(() => import("../pages/Phone"));

const Reception = lazyWithRetry(() => import("../pages/Reception"));
const Welcome = lazyWithRetry(() => import("../pages/Welcome"));
const PrinterSetting = lazyWithRetry(() => import("../pages/PrinterSetting"));

const LogIn = lazyWithRetry(() => import("../pages/LogIn"));

const AttendeeInfo = lazyWithRetry(() => import("../pages/AttendeeInfo"));

const NewAttendee = lazyWithRetry(() => import("../pages/NewAttendeeInfo"));

const Complete = lazyWithRetry(() => import("../pages/Complete"));

const AttendeeInfoConfirm = lazyWithRetry(() => import("../pages/confirm/AttendeeInfoConfirm"));

const NewAttendeeInfoConfirm = lazyWithRetry(
  () => import("../pages/confirm/NewAttendeeInfoConfirm")
);

const NewAttendeeReuse = lazyWithRetry(() => import("../pages/confirm/NewAttendeeReuse"));

const PrivacyPolicy = lazyWithRetry(() => import("../pages/PrivacyPolicy"));

const EditOtherInfo = lazyWithRetry(() => import("../pages/EditOtherInfo"));
const EditGiftMoney = lazyWithRetry(() => import("../pages/EditGiftMoney"));

const NewAttendeeEdit = lazyWithRetry(() => import("../pages/confirm/NewAttendeeEdit"));

const AttendeeEdit = lazyWithRetry(() => import("../pages/confirm/AttendeeEdit"));

const AdminLogin = lazyWithRetry(() => import("../pages/admin/Login"));

const Attendee = lazyWithRetry(() => import("../pages/admin/Attendee"));

const CreateAttendee = lazyWithRetry(() => import("../pages/admin/CreateAttendee"));

const EditAttendee = lazyWithRetry(() => import("../pages/admin/EditAttendee"));

const ItemRecordBook = lazyWithRetry(() => import("../pages/admin/ItemRecordBook"));

const Tsuitocho = lazyWithRetry(() => import("../pages/admin/Tsuitocho"));

const CondolenceGiftSymbolSetting = lazyWithRetry(
  () => import("../pages/admin/CondolenceGiftSymbolSetting")
);

const CreateItem = lazyWithRetry(() => import("../pages/admin/CreateItem"));

const EditItem = lazyWithRetry(() => import("../pages/admin/EditItem"));

const PrintReceipt = lazyWithRetry(() => import("../pages/admin/PrintReceipt"));

const Routers = () => (
  <BrowserRouter>
    <Routes>
      <Route path={ROUTES.HOME} element={<HomePage />} />
      <Route path={ROUTES.RECEPTION} element={<Reception />} />
      <Route path={ROUTES.WELCOME} element={<Welcome />} />
      <Route path={ROUTES.PRINTER_SETTING} element={<PrinterSetting />} />
      <Route path={ROUTES.LOGIN} element={<LogIn />} />
      <Route path={ROUTES.ADMIN_LOGIN} element={<AdminLogin />} />
      <Route path={ROUTES.ADMIN_ATTENDEE} element={<Attendee />} />
      <Route path={ROUTES.ADMIN_ATTENDEE_CREATE} element={<CreateAttendee />} />
      <Route path={ROUTES.ADMIN_ATTENDEE_EDIT} element={<EditAttendee />} />
      <Route path={ROUTES.ADMIN_ITEM_RECORD_BOOK} element={<ItemRecordBook />} />
      <Route path={ROUTES.ADMIN_TSUITOCHO} element={<Tsuitocho />} />
      <Route
        path={ROUTES.ADMIN_CONDOLENCE_GIFT_SYMBOL_SETTING}
        element={<CondolenceGiftSymbolSetting />}
      />
      <Route path={ROUTES.ADMIN_CREATE_ITEM} element={<CreateItem />} />
      <Route path={ROUTES.ADMIN_EDIT_ITEM} element={<EditItem />} />
      <Route path={ROUTES.ADMIN_PRINT_RECEIPT} element={<PrintReceipt />} />
      <Route path={ROUTES.ATTENDEE_INFO} element={<AttendeeInfo />} />
      <Route path={ROUTES.ATTENDEE_CONFIRM} element={<AttendeeInfoConfirm />} />
      <Route path={ROUTES.PHONE} element={<PhonePage />} />
      <Route path={ROUTES.NEW_ATTENDEE_INFO} element={<NewAttendee />} />
      <Route path={ROUTES.EDIT_OTHER_INFO} element={<EditOtherInfo />} />
      <Route path={ROUTES.EDIT_GIFT_MONEY} element={<EditGiftMoney />} />
      <Route path={ROUTES.COMPLETE} element={<Complete />} />
      <Route path={ROUTES.NEW_ATTENDEE_CONFIRM} element={<NewAttendeeInfoConfirm />} />
      <Route path={ROUTES.NEW_ATTENDEE_REUSE} element={<NewAttendeeReuse />} />
      <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />

      <Route path={ROUTES.NEW_ATTENDEE_EDIT} element={<NewAttendeeEdit />} />
      <Route path={ROUTES.ATTENDEE_EDIT} element={<AttendeeEdit />} />
    </Routes>
  </BrowserRouter>
);

export default Routers;
